export enum StatoNotaEnum {
  BOZZA = <any>"BOZZA",
  ELIMINATO = <any>"ELIMINATO",
  APPROVATO = <any>"APPROVATO",
  IN_FIRMA = <any>"IN_FIRMA",
  FIRMATO = <any>"FIRMATO",
  RIFIUTO_CONTABILE = <any>"RIFIUTO_CONTABILE",
  RITIRATO = <any>"RITIRATO",
  PAGATO = <any>"PAGATO",
}
